// export const PRIMARY_COLOR = '#96b541'
// export const PRIMARY_COLOR_LIGTER = '#ecf4dc'
// export const SECONDARY_COLOR = '#009172'

export const PRIMARY_COLOR = '#3971FF'
export const PRIMARY_COLOR_LIGTER = '#FF0049'
export const SECONDARY_COLOR = '#6eb0ff'
